import React from 'react';

import { dateFromTimestamp } from '@consumer-frontend/shared';
import { Container } from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/index.scss';
import '@consumer-bootstrap/pages/account-home/message-detail.scss';

/**
 * @property timestamp Timestamp comes in from the backend with this format: November 8, 2024 8:21 AM CST
 */
export type CnuMessageDetailHeaderPropsT = {
  sender: string;
  subject: string;
  timestamp: string;
};

export type CnuMessageDetailHeaderT = React.FC<CnuMessageDetailHeaderPropsT>;

export const CnuMessageDetailHeader: CnuMessageDetailHeaderT = ({
  sender,
  subject,
  timestamp,
}) => {
  return (
    <Container className="detail-header">
      <span className="detail-header-label h6">Subject</span>
      <p className="detail-header-value" data-chromatic="ignore" data-piiMask>{subject}</p>
      <span className="detail-header-label h6">Sent</span>
      <p className="detail-header-value" data-chromatic="ignore" data-piiMask>{dateFromTimestamp(timestamp)}</p>
      <span className="detail-header-label h6">From</span>
      <p className="detail-header-value" data-chromatic="ignore" data-piiMask>{sender}</p>
    </Container>
  );
};
